import React from "react"

const sufixes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

const getBytes = (bytes, brackets = false) => {
  if (!bytes) return ""
  let i = Math.floor(Math.log(bytes) / Math.log(1024))
  if (`${Math.round(bytes / 1024 ** i)}`.length > 3) i += 1
  return (
    <>
      {brackets && "["}
      {(bytes / 1024 ** i).toFixed(1)}
      {sufixes[i]}
      {brackets && "]"}
    </>
  )
}

const FormatBytes = ({ bytes, brackets, className }) => <span className={className}>{getBytes(bytes, brackets)}</span>

export { FormatBytes }
